import axios from "axios";
import Vue from "vue";
import objectUtils from "../../util/objectUtils";
import helper from "../../util/helper";

export default {
  state: () => ({
    selectedSaleChannel: {},
    saleChannels: [],
  }),

  mutations: {
    setSelectedSaleChannel(state, saleChannel) {
      Vue.set(state, "selectedSaleChannel", saleChannel);
    },
    setSaleChannels(state, saleChannels) {
      Vue.set(state, "saleChannels", saleChannels);
    },
    setDefaultSaleChannelModule(state, saleChannels) {
      Vue.set(state, "selectedSaleChannel", {});
      Vue.set(state, "saleChannels", []);
    },
  },

  actions: {
    //TODO: load, update, create
    createSaleChannel: (context, request) => {
      return axios
        .post(context.getters.getMcServiceUrl + "/sales-channel/entity", request, {})
        .then((response) => {
          return response;
        })
        .catch((err) => {
          return err.response;
        });
    },

    loadPublishedSaleChannels: (context) => {
      return axios.get(context.getters.getMcServiceUrl + "/sales-channel/entity/published").then((response) => {
        return response.data;
      });
    },

    loadSaleChannel: (context, request) => {
      return axios.get(context.getters.getMcServiceUrl + "/sales-channel/entity/" + request.id).then((response) => {
        return response.data;
      });
    },

    loadSaleChannels: (context) => {
      return axios.get(context.getters.getMcServiceUrl + "/sales-channel/entity").then((response) => {
        context.commit("setSaleChannels", response.data);
        return response.data;
      });
    },

    loadSelectedSaleChannelHistory: (context, saleChannel) => {
      return axios.get(context.getters.getMcServiceUrl + "/sales-channel/history/" + saleChannel.id, {}).then((response) => {
        return response.data;
      });
    },

    deleteSaleChannel: (context, saleChannel) => {
      return axios
        .delete(context.getters.getMcServiceUrl + "/sales-channel/entity/" + saleChannel.id)
        .then((response) => {
          let intents = [];
          intents.push(response.data);
          saleChannel.intents = intents;
          saleChannel.intentId = response.data.id;
          return saleChannel;
        })
        .catch((err) => {
          if (err.response.status === 400) {
            context.commit("setWarningModalContent", err.response.data.message);
            return "warning";
          }
        });
    },
    deleteDraftSaleChannel: (context, saleChannel) => {
      return axios
        .delete(context.getters.getMcServiceUrl + "/sales-channel/draft/" + saleChannel.intentId)
        .then((response) => {
          return response;
        })
        .catch((err) => {
          if (err.response.status === 400) {
            context.commit("setWarningModalContent", err.response.data.message);
            return "warning";
          }
        });
    },

    publishSaleChannel: (context, saleChannel) => {
      return axios.get(context.getters.getMcServiceUrl + "/sales-channel/publish/" + saleChannel.intentId).then((response) => {
        if (response.data) {
          response.data.intentId = 0;
        }
        return response.data;
      });
    },
    rejectSaleChannel: (context, saleChannel) => {
      return axios.get(context.getters.getMcServiceUrl + "/sales-channel/reject/" + saleChannel.intentId).then((response) => {
        helper.recallOrRejectEntity(saleChannel, "sale_channel");
        return response.data;
      });
    },
    sendToApprovalSaleChannels: (context, saleChannel) => {
      return axios.get(context.getters.getMcServiceUrl + "/sales-channel/sendToApproval/" + saleChannel.intentId).then((response) => {
        if (saleChannel.intents[0].type === "CREATE_SALE_CHANNEL") {
          saleChannel.intents[0].status = "WAITING_APPROVAL";
        } else if (saleChannel.intents[0].type === "UPDATE_SALE_CHANNEL") {
          saleChannel.intents[0].status = "WAITING_APPROVAL";
        }
        return response.data;
      });
    },
    recallSaleChannel: (context, saleChannel) => {
      return axios.get(context.getters.getMcServiceUrl + "/sales-channel/recall/" + saleChannel.intentId).then((response) => {
        helper.recallOrRejectEntity(saleChannel, "sale_channel");
        return response.data;
      });
    },
    cancelSaleChannel: (context, saleChannel) => {
      return axios.get(context.getters.getMcServiceUrl + "/sales-channel/cancel/" + saleChannel.intentId).then((response) => {
        return response.data;
      });
    },
  },
  getters: {
    getSelectedSaleChannel: (state) => {
      return state.selectedSaleChannel;
    },
    getSaleChannels: (state) => {
      return state.saleChannels;
    },
    getPublishedSaleChannels: (state) => {
      return state.saleChannels.filter((entity) => {
        return entity.intentId === 0;
      });
    },
  },
};
